<span
  class="ki-marker"
  [class.ki-marker--geaendert]="art() === 'geaendert'"
  [class.ki-marker--hervorgehoben]="art() === 'befund' && hervorgehoben()"
  [attr.title]="texte().titel | translate"
>
  <app-ki-mark [size]="13" />
  {{ texte().text | translate }}
</span>
